import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AVIcon from '../../components/icons/AllVoicedIcons';

function supportsFullscreen() {
  return typeof document !== 'undefined' &&
    typeof document.documentElement?.requestFullscreen === 'function' &&
    typeof document.exitFullscreen === 'function';
}

export default function FullscreenControl() {
  const { t } = useTranslation();
  const [isSupported] = useState(supportsFullscreen);
  const [isFullscreen, setIsFullscreen] = useState(
    () => isSupported && Boolean(document.fullscreenElement)
  );

  useEffect(() => {
    if (!isSupported) return undefined;

    const handleFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, [isSupported]);

  if (!isSupported) return null;

  const label = isFullscreen
    ? t('exit_full_screen', 'Exit full screen')
    : t('full_screen', 'Full screen');

  const toggleFullscreen = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await document.documentElement.requestFullscreen();
      }
    } catch (_error) {
      // Fullscreen is optional progressive enhancement; retain the current UI.
    }
  };

  return (
    <button
      type="button"
      className="app-topbar-control app-fullscreen-control"
      title={label}
      aria-label={label}
      aria-pressed={isFullscreen}
      onClick={toggleFullscreen}
    >
      <AVIcon
        icon={isFullscreen ? 'minimize' : 'maximize'}
        size={22}
      />
    </button>
  );
}
